export default "__VITE_ASSET__3367959b__"